import React, { useState } from "react";
import Styled, { css } from "styled-components";

import { ITheme } from "../../interface";
import { useTheme } from "../../context/ThemeProvider";
import { screenSize } from "../../constant";
import skillAndTools from "../../constant/skillAndTools";
const { maxWidth } = screenSize;

const MyToolsContainer = Styled.div`
  height: max-content;
  margin: 2vh -1.5vw;
  padding: 5vh 0;

  @media screen and (max-width: ${maxWidth.mediumPhoneV1}){
    width: 95vw;
    margin: 0;
    position: relative;
    transform: translateX(-50%);
    left: 50%;
  }
`;

const Title = Styled.h2`
    transition: all 0.4s ease-in-out 0s;
    width: max-content;
    font-size: 2em;
    margin: 0;
    @media screen and (max-width: ${maxWidth.mediumPhoneV1}){
      font-size: 1.5em;
    }
`;
const Highlight = Styled.span<{ $props: { theme: ITheme } }>`
    transition: all 0.4s ease-in-out 0s;
    ${({ $props }) => {
      const { theme } = $props;

      return css`
        color: ${theme.colors.hightlightFont};
      `;
    }}
`;

const ToolsWrapper = Styled.div`
    margin: 0 0 4vh 0;
    border-radius: 5px;
    height: max-content;
    width: 100%;
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(4, 1fr);
`;

const Tool = Styled.div<{
  $props: {
    index: number;
    showMyTools: boolean;
  };
}>`
    transition: all 0.2s ease-in-out 0s;
    margin: 0;
    /* ${({ $props }) => {
      const { index, showMyTools } = $props;
      const transitionDelay = index / 10;
      return css`
        transform: translateY(${showMyTools ? 0 : 60}vh);
        opacity: ${showMyTools ? 1 : 0};
        transition: all 0.2s ease-in-out ${transitionDelay}s;
      `;
    }} */
`;

const STBox = Styled.div<{
  $props: {
    theme: ITheme;
  };
}>`
    ${({ $props }) => {
      const { theme } = $props;
      return css`
        background: ${theme.colors.primary};
        color: ${theme.colors.font};
        &:hover {
          box-shadow: #008dda 0px 1px 0px, #008dda 0px 0px 8px;
        }
      `;
    }}
    transition: all 0.2s ease-in-out 0s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    margin: 5px 0;
    padding: 0;
`;

const STIcon = Styled.img<{
  $props: { theme: ITheme; fillIcon: boolean };
}>`
    ${({ $props }) => {
      const { fillIcon, theme } = $props;
      return css`
        ${fillIcon
          ? `
          filter: ${theme.colors.cssFilterPrimary};
        `
          : ""}
      `;
    }}
    transition: all 0.2s ease-in-out 0s;
    pointer-events: none;
    width: 36px;
    height: 36px;
    @media screen and (max-width: ${maxWidth.mediumPhoneV4}) {
      width: 28px;
      height: 28px;
    }
`;

const STName = Styled.p`
    transition: all 0.2s ease-in-out 0s;
    width: 100%;
    text-align: center;
    font-size: 15px;
    margin: 5px 0;
    @media screen and (max-width: ${maxWidth.mediumPhoneV4}) {
      font-size: 12px;
    }
`;

const LoadMore = Styled.div<{
  $props: { theme: ITheme };
}>`
    ${({ $props }) => {
      const { theme } = $props;
      return css`
        background: ${theme.colors.primary};
        color: ${theme.colors.font};
        &:hover {
          box-shadow: #008dda 0px 1px 0px, #008dda 0px 0px 8px;
        }
      `;
    }}
    transition: all 0.2s ease-in-out 0s;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    border-radius: 4px;
    cursor: pointer;
`;

function MyTools({ showMyTools }: { showMyTools: boolean }) {
  const { theme, oppositeTheme } = useTheme();
  const [displayST, setDisplayST] = useState(skillAndTools.slice(0, 8));

  const loadMore = () => {
    setDisplayST((prevDisplay) => {
      let newDisplay = [...prevDisplay];
      if (newDisplay.length >= skillAndTools.length)
        newDisplay = skillAndTools.slice(0, 8);
      else
        newDisplay.push(
          ...skillAndTools.slice(newDisplay.length, newDisplay.length + 8)
        );
      return newDisplay;
    });
  };

  return (
    <MyToolsContainer>
      <Title>
        <Highlight $props={{ theme }}>Tools</Highlight> I Use
      </Title>
      <ToolsWrapper>
        {displayST.map(({ icon, name, fillIcon }, index) => {
          return (
            <Tool key={`tool-${index}`} $props={{ index, showMyTools }}>
              <STBox $props={{ theme: oppositeTheme }}>
                <STIcon $props={{ fillIcon, theme }} src={icon} />
                <STName>{name}</STName>
              </STBox>
            </Tool>
          );
        })}
      </ToolsWrapper>
      <LoadMore $props={{ theme: oppositeTheme }} onClick={loadMore}>
        {displayST.length < skillAndTools.length ? "Load More" : "That's All, reset?"}
      </LoadMore>
    </MyToolsContainer>
  );
}

export default MyTools;
